export default __webpack_public_path__ + "static/media/Organigrama.f801c69c.jpg";